// App.js
import React, { useEffect } from 'react';
import './App.css';
import useSticky from "../hooks/useSticky.js";
import Welcome from "../components/Home/Header/Welcome.js";
import NavBar from "../components/Home/Header/NavBar.js";
import { ParallaxProvider } from 'react-scroll-parallax';
import AccessibilityWidget from '../components/Home/AccessibilityWidget.js';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import TermsOfService from '../components/Other-Pages/TermsOfService.js';
import PrivacyPolicy from '../components/Other-Pages/PrivacyPolicy.js';
import CookiePolicy from '../components/Other-Pages/CookiePolicy.js';

// ✅ import your homepage sections wrapper
import HomePage from '../components/Home/Home.js';

function App() {
  const { isSticky, element } = useSticky();

  useEffect(() => {
    const script = document.createElement('script');
    script.id = "cookieyes";
    script.type = "text/javascript";
    script.src =
      "https://cdn-cookieyes.com/client_data/a750ebe884acadf7f402887081dbf823/script.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Router>
      <ParallaxProvider>
        {/* ✅ Things you want on EVERY page */}
        <NavBar sticky={isSticky} />
        <AccessibilityWidget />
        <Welcome element={element} />
        {/* ✅ Only the content inside Switch changes by route */}
        <Switch>
          <Route path="/terms-of-service" component={TermsOfService} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/cookie-policy" component={CookiePolicy} />

          {/* ✅ HOME ROUTE: Welcome + full homepage */}
          <Route exact path="/">
            <>
              <HomePage />
            </>
          </Route>

          {/* ✅ Optional fallback: send unknown routes to home */}
          <Route path="*">
            <>
              <HomePage />
            </>
          </Route>
        </Switch>
      </ParallaxProvider>
    </Router>
  );
}

export default App;
